
import React from "react"
import Props from './svgProps'

const Environment2Svg = ({width, height, fill}:Props) => {
    return (
      <svg
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22 23"
        fill="none">
        <path d="M1.0874 11H21.0874M1.0874 11C1.0874 16.5228 5.56455 21 11.0874 21M1.0874 11C1.0874 5.47715 5.56455 1 11.0874 1M21.0874 11C21.0874 16.5228 16.6103 21 11.0874 21M21.0874 11C21.0874 5.47715 16.6103 1 11.0874 1M11.0874 1C13.5887 3.73835 15.0102 7.29203 15.0874 11C15.0102 14.708 13.5887 18.2616 11.0874 21M11.0874 1C8.58612 3.73835 7.16465 7.29203 7.0874 11C7.16465 14.708 8.58612 18.2616 11.0874 21" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>

      </svg>
    )
}

export default Environment2Svg
